<div bsModal #modal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title">Division #{{ divisionId }} – Users</h4>
      </div>
      <div class="modal-body">
        <table class="table table-responsive-sm table-hover table-outline mb-0">
          <thead class="thead-light">
            <tr>
              <th>#</th>
              <th>User ID</th>
              <th>Display Name</th>
              <th>Active</th>
              <th>Game</th>
              <th>Points</th>
              <th>Reward Granted</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            @if (isLoading) {
              <tr>
                <td colspan="8" class="text-center">
                  <span class="spinner-border spinner-border-sm"></span> Loading...
                </td>
              </tr>
            } @else if (users.length === 0) {
              <tr>
                <td colspan="8" class="text-center text-muted">No users found.</td>
              </tr>
            } @else {
              @for (user of users; track user.userId; let i = $index) {
                <tr>
                  <td>{{ i + 1 }}</td>
                  <td>{{ user.userId }}</td>
                  <td>{{ getDisplayName(user) }}</td>
                  <td>
                    @if (user.isActive) {
                      <span class="badge bg-success">Yes</span>
                    } @else {
                      <span class="badge bg-secondary">No</span>
                    }
                  </td>
                  <td>{{ user.game }}</td>
                  <td>{{ user.point }}</td>
                  <td>
                    @if (user.isRewardGranted) {
                      <span class="badge bg-success">Yes</span>
                    } @else {
                      <span class="badge bg-secondary">No</span>
                    }
                  </td>
                  <td>
                    <a class="btn btn-sm btn-primary" routerLink="/backoffice/management/user-details" [queryParams]="{ id: user.userId }" target="_blank" tooltip="User details" placement="top"><i class="fa fa-search"></i></a>
                  </td>
                </tr>
              }
            }
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="modal.hide()">Close</button>
      </div>
    </div>
  </div>
</div>
